
  import { Component, Vue, Prop } from 'vue-property-decorator'
  import { commonModule, appointmentsRecurrencesModule, installationsModule } from '@/store/modules/store-accessor'

  @Component
  export default class DeleteRecurringAppointmentSeriesModal extends Vue {
    @Prop()
    payload!: any;

    isDeletingSeries = false;

    async hideModal () {
      commonModule.hideModal();
    }

    async mounted() {
      commonModule.initSnackbar({});
    }

    async doDelete () {
        this.isDeletingSeries = true;
        await appointmentsRecurrencesModule.deleteAppointmentRecurrenceSeries(this.payload.recurrence_id);
        if(this.payload.installation_id) {
          await installationsModule.getInstallationDetailsAppointments(this.payload.installation_id);
          await installationsModule.invalidateInstallationTab({tabs: ['jobs'], installationId: this.payload.installation_id});
        }
        this.hideModal()
    }
  };
  